 <template>
  <div class="info-region-container">
    <div class="all-content-container" style="margin: 0 auto; width: 100%">
      <div class="container1">
        <div class="titlemaun" style="">
          <h4>大棚调控设备</h4>
        </div>
        <el-form :inline="true" :model="searchForm" class="demo-form-inline">
          <el-form-item label="大棚名称：">
            <el-cascader
              expand-trigger="hover"
              v-model="groupIdArr"
              :options="groupArray"
              :props="optionProps"
              @change="groupChange"
              placeholder="请选择大棚名称"
              collapse-tags
            ></el-cascader>
          </el-form-item>
          <el-form-item label="设备类型：" prop="type">
            <el-select
              v-model="searchForm.type"
              placeholder="请选择设备类型"
              @change="handleSearch"
            >
              <el-option label="数值" value="0"></el-option>
              <el-option label="开关" value="3"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="设备标签：">
            <el-select
              v-model="searchForm.deviceSign"
              clearable
              placeholder="请选择设备标签"
              @change="handleSearch"
            >
              <el-option
                v-for="item in paramTypeArray"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" class="button" @click="handleSearch()"
              >查询</el-button
            >
            <el-button type="button" ass="button" @click="handleReset()"
              >重置</el-button
            >
          </el-form-item>
        </el-form>
      </div>
      <div class="info-content-container" style="display: flex">
        <div class="table_content1 table_content2">
          <el-table
            :data="tableData"
            align="center"
            class="data-table"
            v-loading="loading"
            style="width: 100%"
            height="500"
            :header-cell-style="{ background: '#F4F5F7' }"
          >
            <el-table-column label="设备名称" align="center">
              <template slot-scope="scope">
                <p>{{ scope.row.deviceName }}</p>
              </template>
            </el-table-column>
            <el-table-column label="属性名称" align="center">
              <template slot-scope="scope">
                <p>{{ scope.row.attributeName }}</p>
              </template>
            </el-table-column>
            <el-table-column label="设备标签" align="center">
              <template slot-scope="scope">
                <p>{{ scope.row.deviceSign | paramTypeName }}</p>
              </template>
            </el-table-column>
            <el-table-column fixed="right" align="center" label="操作">
              <template slot-scope="scope">
                <el-button
                  type="text"
                  size="small"
                  @click="handleRemove(scope.row)"
                  >移除</el-button
                >
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div style="width: 2%"></div>
        <div class="table_content1 table_content2">
          <el-table
            :data="tableData2"
            align="center"
            class="data-table"
            v-loading="loading"
            style="width: 100%"
            height="500"
            :header-cell-style="{ background: '#F4F5F7' }"
          >
            <el-table-column fixed="left" align="center" label="操作">
              <template slot-scope="scope">
                <el-button
                  type="text"
                  size="small"
                  @click="handleRemoveBack(scope.row)"
                  >移回</el-button
                >
              </template>
            </el-table-column>
            <el-table-column label="设备名称" align="center">
              <template slot-scope="scope">
                <p>{{ scope.row.deviceName }}</p>
              </template>
            </el-table-column>
            <el-table-column label="属性名称" align="center">
              <template slot-scope="scope">
                <p>{{ scope.row.attributeName }}</p>
              </template>
            </el-table-column>
            <el-table-column label="设备标签" align="center">
              <template slot-scope="scope">
                <p>{{ scope.row.deviceSign | paramTypeName }}</p>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
    </div>
  </div>
</template>
 <script>
export default {
  data() {
    return {
      searchForm: {
        groupId: "",
        type: "",
        deviceSign: "",
      },
      groupIdArr: [],
      tableData: [], // 可调控设备列表
      tableData2: [], // 不可调控设备列表
      loading: false,
      groupArray: [], // 大棚名称数组
      optionProps: {
        value: "id",
        label: "name",
        children: "children",
        checkStrictly: true,
        multiple: false,
      },
      paramTypeArray: this.$filters.paramTypeArray(),
    };
  },
  created() {
    // 获取分组列表
    this.getGroupList();
  },
  methods: {
    // 查询
    handleSearch() {
      if (this.searchForm.groupId == "") {
        this.$message({
          type: "error",
          message: "请选择大棚",
        });
        return;
      }

      if (this.searchForm.type == "") {
        this.$message({
          type: "error",
          message: "请选择设备类型",
        });
        return;
      }

      // 获取大棚调控设备列表
      this.getControlDevices();

      // 获取大棚不可调控设备列表
      this.getRemoveControlDevices();
    },
    // 默认
    defaultData() {
      // 默认第一个分组
      if (this.groupArray.length > 0) {
        this.groupIdArr = [
          this.groupArray[0].id,
          this.groupArray[0].children[0].id,
        ];
        this.searchForm.groupId = this.groupIdArr[1];
      }

      // 默认数值
      this.searchForm.type = "0";
    },
    // 重置
    handleReset() {
      this.searchForm = {
        groupId: "",
        type: "",
        deviceSign: "",
      };
      this.groupIdArr = [];

      // 默认数据
      this.defaultData();

      this.handleSearch();
    },
    // 获取大棚调控设备列表
    getControlDevices() {
      this.$api.growthModel
        .getControlDevices({
          groupId: this.searchForm.groupId,
          type: this.searchForm.type,
          deviceSign: this.searchForm.deviceSign,
        })
        .then((res) => {
          this.tableData = res.data;
        });
    },
    // 获取大棚不可调控设备列表
    getRemoveControlDevices() {
      this.$api.growthModel
        .getRemoveControlDevices({
          groupId: this.searchForm.groupId,
          type: this.searchForm.type,
          deviceSign: this.searchForm.deviceSign,
        })
        .then((res) => {
          this.tableData2 = res.data;
        });
    },
    // 移回
    handleRemoveBack(row) {
      this.$api.growthModel.delGrowthModelDeviceSign(row.id).then((res) => {
        if (res.code == 200) {
          this.handleSearch();
        }
      });
    },
    // 移除
    handleRemove(row) {
      this.$api.growthModel
        .saveGrowthModelDeviceSign({
          groupId: this.searchForm.groupId,
          type: this.searchForm.type,
          eid: row.deviceId,
          attributeId: row.attributeId,
        })
        .then((res) => {
          if (res.code == 200) {
            this.handleSearch();
          }
        });
    },
    // 大棚下拉切换
    groupChange() {
      // 不是三级分类
      if (
        !this.groupIdArr ||
        this.groupIdArr.length != 2
      ) {
        this.groupIdArr = [];
        this.searchForm.groupId = "";
      } else {
        this.searchForm.groupId = this.groupIdArr[1];
        this.handleSearch();
      }
    },
    // 获取分组列表
    getGroupList() {
      this.$api.system.getGroupList().then((res) => {
        if (res.code == 200) {
          this.groupArray = res.data;

          // 默认数据
          this.defaultData();

          // 查询
          this.handleSearch();
        }
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.container1 {
  border: 1px solid rgba(232, 232, 232, 1);
}

.el-button {
  line-height: 0;
}

.all-content-container {
  width: 100%;
}

.titlemaun {
  display: flex;
  justify-content: space-between;
  height: 48px;
  border-bottom: 1px solid #ededed;
}

h4 {
  font-size: 14px;
  font-weight: 550;
  color: #000;
  height: 48px;
  line-height: 48px;
  padding-left: 18px;
}

.table_content2 {
  margin-top: 10px;
  width: 49%;
  height: 500px;
  overflow-y: auto;
  margin-bottom: 20px;
}
</style>